const TEXT = {
  en: {
    direction: "ltr",
    navigation: {
      parent: "User Management",
      pagesLabel: "User Management pages",
      children: ["Customers", "Merchants", "Registration Reviews"]
    },
    customers: "Customers",
    merchants: "Merchants",
    registrationReviews: "Registration Reviews",
    total: "Total",
    refresh: "Refresh",
    rowsPerPage: "Rows per page",
    city: "City",
    storeName: "Store name",
    storeNameAr: "Store name ar",
    storeNameEn: "Store name en",
    customerName: "Customer name",
    englishStoreName: "English store name",
    ownerName: "Owner name",
    review: "Review",
    showNationalId: "Show national ID",
    hideNationalId: "Hide national ID",
    policyAcceptedAt: "Accepted at",
    policyIp: "IP address",
    policySource: "Source",
    registrationReviewType: "Registration type",
    searchCustomerReviews: "Search customer registrations...",
    searchMerchantReviews: "Search merchant, owner, or registration number",
    searchMerchantRegistrations: "Search merchant registrations...",
    reviewStatus: "Review status",
    allReviewStatuses: "All review statuses",
    documentStatus: "Document status",
    reviewRegistration: "Review registration",
    noRegistrationReviews: "No registrations match these filters.",
    noQueuedRegistrations: "No registrations are waiting for review.",
    noQueuedRegistrationsHint: "New pending registrations will appear here automatically.",
    noFilterMatchesHint: "Adjust or clear the filters to see other registrations.",
    securePreview: "Protected document preview",
    viewerControls: "Document view controls",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    rotateLeft: "Rotate left",
    rotateRight: "Rotate right",
    resetView: "Reset view",
    closeViewer: "Close document preview",
    registrationReviewQueueHint: "Pending, rejected, and action-required registrations",
    customerRegistration: "Customer registration",
    merchantRegistration: "Merchant registration",
    registrationReviewDetails: "Registration review details",
    registrationOverviewHint: "Account information submitted for review",
    ownerFullLegalName: "Owner full legal name",
    accountIp: "Registration IP",
    profileImage: "Profile image",
    openProfileImage: "Open profile image in protected preview",
    reviewedAt: "Last reviewed",
    previousUploadAttempts: "Previous upload attempts",
    previousUploadAttemptsHint: "Review the current and previous document uploads and their staff decisions.",
    attempt: "Attempt",
    uploadedAt: "Uploaded at",
    documentGroup: "Document",
    reviewer: "Reviewer",
    currentUpload: "Current upload",
    notReviewedYet: "Not reviewed yet",
    reviewerUnavailable: "Reviewer unavailable",
    images: "Images",
    viewImages: "View images",
    noUploadAttempts: "No upload attempts are available.",
    protectedDocumentsHint: "Authenticated preview without public document links",
    nationalIdFront: "National ID — front",
    nationalIdBack: "National ID — back",
    legacyNationalId: "Legacy national ID evidence",
    commercialRegister: "Commercial register",
    taxCard: "Tax card",
    documentUploaded: "Uploaded",
    documentMissing: "Not uploaded",
    openingDocument: "Opening…",
    loadingDocumentPreview: "Loading protected image…",
    policyEvidenceHint: "Policy versions captured with this registration",
    privacyPolicyVersion: "Privacy policy version",
    termsVersion: "Terms version",
    usagePolicyVersion: "Usage policy version",
    reviewDecision: "Review decision",
    reviewDecisionHint: "Choose one outcome for the registration and all required documents",
    merchantReviewDecisionHint: "Review the Commercial Register and Tax Card independently",
    groupNotInCurrentSubmission: "No new upload was submitted for this document. Its current decision remains unchanged.",
    merchantGroupDecisionHint: "Approve this document or request a clearer replacement",
    merchantGlobalRejectionTitle: "Reject the merchant registration",
    merchantGlobalRejectionHint: "Use one rejection only when the merchant registration as a whole cannot be accepted. Existing document review progress is preserved for reconsideration.",
    merchantGlobalRejectionSelected: "Merchant-wide rejection is selected. Existing Commercial Register and Tax Card decisions will be preserved.",
    selectMerchantGlobalRejection: "Reject merchant registration",
    cancelMerchantGlobalRejection: "Cancel merchant rejection",
    merchantGlobalRejectionReasonHint: "Explain why the merchant registration as a whole cannot be accepted",
    merchantRejectedReviewTitle: "Previously rejected registration",
    merchantRejectedReviewHint: "Review the existing rejection reason or reopen the registration to replace it with a new document-level decision.",
    merchantRejectedReviewSelected: "This registration remains rejected. Document decisions are preserved and cannot be edited until you reopen the review.",
    reconsiderMerchantRejection: "Reconsider this decision",
    restoreMerchantRejection: "Keep registration rejected",
    merchantReconsiderationActive: "Reconsideration mode is active. Confirm Approve or Request re-upload for each document, then save the revised decision.",
    merchantDocumentDecisionRequired: "Choose the new decision for this document before saving the reconsideration.",
    saveRevisedDecision: "Save revised decision",
    reviewGroups: {
      NATIONAL_ID: "National ID (front and back)",
      COMMERCIAL_REGISTER: "Commercial register",
      TAX_CARD: "Tax card"
    },
    groupDecision: "Decision",
    chooseDecision: "Choose a decision",
    approve: "Approve",
    approveHint: "Verify the registration and allow the account to continue",
    requireReupload: "Require re-upload",
    requireReuploadHint: "Ask the user to replace unclear or incomplete documents",
    reject: "Reject",
    rejectHint: "Decline the registration with a clear user-facing reason",
    reviewReasonHint: "Explain the rejection or documents that must be replaced",
    internalNotes: "Internal notes",
    internalNotesHint: "Visible to authorized staff only",
    internalNotesHistory: "Internal notes history",
    noInternalNotes: "No internal notes have been saved yet.",
    reviewNoteSource: "Review note",
    reopenReasonSource: "Reopen reason",
    bilingualReasonRequired: "Enter the reason in both Arabic and English",
    birthDate: "Birth date",
    gender: "Gender",
    male: "Male",
    female: "Female",
    saveReviewDecisions: "Save review decisions",
    saveReviewDecision: "Save review decision",
    approveRegistration: "Approve registration",
    requestReupload: "Request re-upload",
    rejectRegistration: "Reject registration",
    searchCustomers: "Search Customers...",
    searchMerchants: "Search Merchants...",
    filters: "Filters",
    clearFilters: "Clear filters",
    all: "All",
    yes: "Yes",
    no: "No",
    active: "Active",
    blocked: "Blocked",
    deleted: "Deleted",
    verified: "Verified",
    unverified: "Unverified",
    evidenceCaptured: "Evidence captured",
    evidenceMissing: "Legacy / not captured",
    registeredFrom: "Registered from",
    registeredTo: "Registered to",
    sortBy: "Sort by",
    allDates: "All dates",
    today: "Today",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    last90Days: "Last 90 days",
    customRange: "Custom range",
    editCustomRange: "Edit custom registration date range",
    customRegistrationRange: "Custom registration date range",
    fromDate: "From date",
    toDate: "To date",
    apply: "Apply",
    country: "Country",
    locations: "Locations",
    allLocations: "All locations",
    allCountries: "All countries",
    allCities: "All cities",
    governorate: "Governorate",
    category: "Category",
    hasBranch: "Has branch",
    hasPlan: "Has plan",
    hasPaymentMethod: "Has payment method",
    newest: "Newest first",
    oldest: "Oldest first",
    name: "Name",
    email: "Email",
    phone: "Phone",
    nationalId: "National ID",
    location: "Location",
    registrationNumber: "Registration number",
    profileCompleteness: "Profile completeness",
    merchantSetupProgress: "Merchant setup progress",
    branchSetup: "Branch added",
    planSetup: "Installment plan added",
    paymentMethodSetup: "Payment method added",
    setupBranches: "Branches",
    setupPlans: "Plans",
    setupPaymentMethods: "Payment methods",
    noSetupBranches: "No branches have been added.",
    noSetupPlans: "No installment plans have been added.",
    noSetupPaymentMethods: "No payment methods have been added.",
    arabicName: "Arabic name",
    englishName: "English name",
    branchAddress: "Address",
    coordinates: "Coordinates",
    createdAt: "Created",
    updatedAt: "Last updated",
    installmentType: "Installment interval",
    duration: "Duration",
    weekly: "Weekly",
    monthly: "Monthly",
    weeks: "weeks",
    months: "months",
    archived: "Archived",
    paymentMethodDetails: "Merchant-provided details",
    openInGoogleMaps: "Open in Google Maps",
    completed: "Completed",
    notCompleted: "Not completed",
    registrationDate: "Registration date",
    verification: "Verification",
    status: "Status",
    actions: "Actions",
    viewDetails: "View details",
    noCustomers: "No approved customers match these filters.",
    noMerchants: "No approved merchants match these filters.",
    noApprovedAccountsHint: "Approved accounts will appear here when available.",
    customerAccount: "Customer account",
    merchantAccount: "Merchant account",
    accountDetails: "Account details",
    resizeDrawer: "Resize account details drawer",
    resizeRegistrationReviewDrawer: "Resize registration review details drawer",
    accountOverviewHint: "Identity, contact, and registration information",
    accountActions: "Account actions",
    accountActionsHint: "Administrative changes are audited and may require a reason",
    lifecycleStatus: "Account status",
    setupStatus: "Setup status",
    overview: "Overview",
    documentsTab: "Documents",
    policiesTab: "Policies",
    operationsTab: "Operations",
    logsTab: "Logs",
    registrationDocuments: "Registration / Documents",
    policyEvidence: "Policy Evidence",
    operationsSummary: "Operations Summary",
    auditHistory: "Audit History",
    editProfile: "Edit profile",
    block: "Block",
    unblock: "Unblock",
    reopenReview: "Reopen review",
    softDelete: "Delete account",
    restore: "Restore account",
    reason: "Reason",
    reasonHint: "Enter the required internal reason",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save changes",
    loading: "Loading…",
    pending: "Pending review",
    rejected: "Rejected",
    reupload: "Re-upload required",
    approved: "Approved",
    logEvent: "Event",
    logDate: "Date and time",
    logActor: "Performed by",
    logChanges: "Changes",
    noAuditLogs: "No account activity has been recorded.",
    systemActor: "System",
    auditActions: {
      PROFILE_UPDATED: "Profile updated",
      REVIEW_DECIDED: "Registration review decided",
      BLOCKED: "Account blocked",
      UNBLOCKED: "Account unblocked",
      REVIEW_REOPENED: "Moved to pending review",
      SOFT_DELETED: "Account deleted",
      SELF_DELETED: "Account deleted by its owner",
      RESTORED: "Account restored",
      DOCUMENTS_SUBMITTED: "Documents submitted"
    },
    auditActorTypes: {
      SUPER_ADMIN: "Super admin",
      ADMIN: "Admin",
      CUSTOMER: "Customer",
      MERCHANT: "Merchant",
      SYSTEM: "System"
    },
    auditFields: {
      fullName: "Customer name",
      nameAr: "Arabic store name",
      nameEn: "English store name",
      ownerFullLegalName: "Owner legal name",
      phone: "Phone",
      nationalId: "National ID",
      registrationNumber: "Registration number",
      decision: "Review decision",
      compatibilityAlias: "Compatibility action"
    },
    statusLabels: {
      PENDING_REVIEW: "Pending review",
      REUPLOAD_REQUIRED: "Re-upload required",
      REJECTED: "Rejected",
      APPROVED: "Approved"
    },
    documentHistory: "Submission history",
    viewDocument: "View document",
    previous: "Previous",
    next: "Next",
    page: "Page"
  },
  ar: {
    direction: "rtl",
    navigation: {
      parent: "إدارة المستخدمين",
      pagesLabel: "صفحات إدارة المستخدمين",
      children: ["العملاء", "التجار", "مراجعات التسجيل"]
    },
    customers: "العملاء",
    merchants: "التجار",
    registrationReviews: "مراجعات التسجيل",
    total: "الإجمالي",
    refresh: "تحديث",
    rowsPerPage: "عدد الصفوف في الصفحة",
    city: "المدينة",
    storeName: "اسم المتجر",
    storeNameAr: "اسم المتجر بالعربية",
    storeNameEn: "اسم المتجر بالإنجليزية",
    customerName: "اسم العميل",
    englishStoreName: "اسم المتجر بالإنجليزية",
    ownerName: "اسم المالك",
    review: "مراجعة",
    showNationalId: "إظهار الرقم القومي",
    hideNationalId: "إخفاء الرقم القومي",
    policyAcceptedAt: "وقت الموافقة",
    policyIp: "عنوان IP",
    policySource: "المصدر",
    registrationReviewType: "نوع التسجيل",
    searchCustomerReviews: "ابحث في تسجيلات المشترين...",
    searchMerchantReviews: "ابحث بالمتجر أو المالك أو رقم السجل",
    searchMerchantRegistrations: "ابحث في تسجيلات التجار...",
    reviewStatus: "حالة المراجعة",
    allReviewStatuses: "كل حالات المراجعة",
    documentStatus: "حالة المستندات",
    reviewRegistration: "مراجعة التسجيل",
    noRegistrationReviews: "لا توجد تسجيلات تطابق عوامل التصفية.",
    noQueuedRegistrations: "لا توجد تسجيلات بانتظار المراجعة.",
    noQueuedRegistrationsHint: "ستظهر التسجيلات الجديدة المعلقة هنا تلقائياً.",
    noFilterMatchesHint: "عدّل عوامل التصفية أو امسحها لعرض تسجيلات أخرى.",
    securePreview: "معاينة مستند محمية",
    viewerControls: "أدوات عرض المستند",
    zoomIn: "تكبير",
    zoomOut: "تصغير",
    rotateLeft: "تدوير لليسار",
    rotateRight: "تدوير لليمين",
    resetView: "إعادة ضبط العرض",
    closeViewer: "إغلاق معاينة المستند",
    registrationReviewQueueHint: "التسجيلات المعلقة والمرفوضة والتي تتطلب إجراء",
    customerRegistration: "تسجيل مشتري",
    merchantRegistration: "تسجيل تاجر",
    registrationReviewDetails: "تفاصيل مراجعة التسجيل",
    registrationOverviewHint: "بيانات الحساب المقدمة للمراجعة",
    ownerFullLegalName: "الاسم القانوني الكامل للمالك",
    accountIp: "عنوان IP عند التسجيل",
    profileImage: "صورة الحساب",
    openProfileImage: "فتح صورة الحساب في المعاينة المحمية",
    reviewedAt: "آخر مراجعة",
    previousUploadAttempts: "محاولات الرفع السابقة",
    previousUploadAttemptsHint: "راجع الرفع الحالي والمحاولات السابقة وقرارات الموظفين المرتبطة بها.",
    attempt: "المحاولة",
    uploadedAt: "وقت الرفع",
    documentGroup: "المستند",
    reviewer: "المراجع",
    currentUpload: "الرفع الحالي",
    notReviewedYet: "لم تتم المراجعة بعد",
    reviewerUnavailable: "بيانات المراجع غير متاحة",
    images: "الصور",
    viewImages: "عرض الصور",
    noUploadAttempts: "لا توجد محاولات رفع متاحة.",
    protectedDocumentsHint: "معاينة موثقة دون روابط عامة للمستندات",
    nationalIdFront: "بطاقة الرقم القومي — الوجه الأمامي",
    nationalIdBack: "بطاقة الرقم القومي — الوجه الخلفي",
    legacyNationalId: "مستند هوية قديم",
    commercialRegister: "السجل التجاري",
    taxCard: "البطاقة الضريبية",
    documentUploaded: "تم الرفع",
    documentMissing: "غير مرفوع",
    openingDocument: "جارٍ الفتح…",
    loadingDocumentPreview: "جارٍ تحميل الصورة المحمية…",
    policyEvidenceHint: "إصدارات السياسات المحفوظة مع هذا التسجيل",
    privacyPolicyVersion: "إصدار سياسة الخصوصية",
    termsVersion: "إصدار الشروط والأحكام",
    usagePolicyVersion: "إصدار سياسة الاستخدام",
    reviewDecision: "قرار المراجعة",
    reviewDecisionHint: "اختر نتيجة واحدة للتسجيل وجميع المستندات المطلوبة",
    merchantReviewDecisionHint: "راجع السجل التجاري والبطاقة الضريبية بشكل مستقل",
    groupNotInCurrentSubmission: "لم يتم رفع مستند جديد لهذه المجموعة، وسيظل قرارها الحالي دون تغيير.",
    merchantGroupDecisionHint: "اعتمد هذا المستند أو اطلب رفع بديل أوضح",
    merchantGlobalRejectionTitle: "رفض تسجيل التاجر",
    merchantGlobalRejectionHint: "استخدم قرار رفض واحداً فقط عندما يتعذر قبول تسجيل التاجر بالكامل، مع الاحتفاظ بنتائج مراجعة المستندات لإمكانية إعادة النظر.",
    merchantGlobalRejectionSelected: "تم اختيار رفض تسجيل التاجر بالكامل، مع الاحتفاظ بقرارات السجل التجاري والبطاقة الضريبية الحالية.",
    selectMerchantGlobalRejection: "رفض تسجيل التاجر بالكامل",
    cancelMerchantGlobalRejection: "إلغاء رفض التاجر",
    merchantGlobalRejectionReasonHint: "وضح سبب تعذر قبول تسجيل التاجر بالكامل",
    merchantRejectedReviewTitle: "تسجيل مرفوض سابقاً",
    merchantRejectedReviewHint: "راجع سبب الرفض الحالي أو أعد فتح المراجعة لاستبداله بقرار جديد لكل مستند.",
    merchantRejectedReviewSelected: "لا يزال هذا التسجيل مرفوضاً. تم الاحتفاظ بقرارات المستندات ولا يمكن تعديلها قبل إعادة فتح المراجعة.",
    reconsiderMerchantRejection: "إعادة النظر في القرار",
    restoreMerchantRejection: "الإبقاء على رفض التسجيل",
    merchantReconsiderationActive: "وضع إعادة النظر مفعل. أكد اعتماد أو طلب إعادة رفع كل مستند، ثم احفظ القرار المعدل.",
    merchantDocumentDecisionRequired: "اختر القرار الجديد لهذا المستند قبل حفظ إعادة النظر.",
    saveRevisedDecision: "حفظ القرار المعدل",
    reviewGroups: {
      NATIONAL_ID: "بطاقة الرقم القومي (الوجهين)",
      COMMERCIAL_REGISTER: "السجل التجاري",
      TAX_CARD: "البطاقة الضريبية"
    },
    groupDecision: "القرار",
    chooseDecision: "اختر قراراً",
    approve: "اعتماد",
    approveHint: "اعتماد التسجيل والسماح للحساب بالمتابعة",
    requireReupload: "طلب إعادة الرفع",
    requireReuploadHint: "اطلب من المستخدم استبدال المستندات غير الواضحة أو الناقصة",
    reject: "رفض",
    rejectHint: "ارفض التسجيل مع توضيح سبب مفهوم للمستخدم",
    reviewReasonHint: "وضح سبب الرفض أو المستندات المطلوب استبدالها",
    internalNotes: "ملاحظات داخلية",
    internalNotesHint: "تظهر للموظفين المخولين فقط",
    internalNotesHistory: "سجل الملاحظات الداخلية",
    noInternalNotes: "لم يتم حفظ ملاحظات داخلية حتى الآن.",
    reviewNoteSource: "ملاحظة مراجعة",
    reopenReasonSource: "سبب إعادة فتح المراجعة",
    bilingualReasonRequired: "أدخل السبب باللغتين العربية والإنجليزية",
    birthDate: "تاريخ الميلاد",
    gender: "النوع",
    male: "ذكر",
    female: "أنثى",
    saveReviewDecisions: "حفظ قرارات المراجعة",
    saveReviewDecision: "حفظ قرار المراجعة",
    approveRegistration: "اعتماد التسجيل",
    requestReupload: "طلب إعادة الرفع",
    rejectRegistration: "رفض التسجيل",
    searchCustomers: "ابحث عن العملاء...",
    searchMerchants: "ابحث عن التجار...",
    filters: "عوامل التصفية",
    clearFilters: "مسح التصفية",
    all: "الكل",
    yes: "نعم",
    no: "لا",
    active: "نشط",
    blocked: "محظور",
    deleted: "محذوف",
    verified: "موثّق",
    unverified: "غير موثّق",
    evidenceCaptured: "تم حفظ الموافقة",
    evidenceMissing: "قديم / لم يتم تسجيله",
    registeredFrom: "مسجل من",
    registeredTo: "مسجل حتى",
    sortBy: "الترتيب حسب",
    allDates: "كل التواريخ",
    today: "اليوم",
    last7Days: "آخر 7 أيام",
    last30Days: "آخر 30 يوماً",
    last90Days: "آخر 90 يوماً",
    customRange: "نطاق مخصص",
    editCustomRange: "تعديل النطاق المخصص لتاريخ التسجيل",
    customRegistrationRange: "نطاق مخصص لتاريخ التسجيل",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    apply: "تطبيق",
    country: "الدولة",
    locations: "المواقع",
    allLocations: "كل المواقع",
    allCountries: "كل الدول",
    allCities: "كل المدن",
    governorate: "المحافظة",
    category: "الفئة",
    hasBranch: "لديه فرع",
    hasPlan: "لديه خطة",
    hasPaymentMethod: "لديه وسيلة دفع",
    newest: "الأحدث أولاً",
    oldest: "الأقدم أولاً",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    nationalId: "الرقم القومي",
    location: "الموقع",
    registrationNumber: "رقم السجل التجاري",
    profileCompleteness: "اكتمال الملف",
    merchantSetupProgress: "تقدم إعداد حساب التاجر",
    branchSetup: "إضافة فرع",
    planSetup: "إضافة خطة تقسيط",
    paymentMethodSetup: "إضافة وسيلة دفع",
    setupBranches: "الفروع",
    setupPlans: "الخطط",
    setupPaymentMethods: "وسائل الدفع",
    noSetupBranches: "لم تتم إضافة فروع.",
    noSetupPlans: "لم تتم إضافة خطط تقسيط.",
    noSetupPaymentMethods: "لم تتم إضافة وسائل دفع.",
    arabicName: "الاسم بالعربية",
    englishName: "الاسم بالإنجليزية",
    branchAddress: "العنوان",
    coordinates: "الإحداثيات",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "آخر تحديث",
    installmentType: "دورية القسط",
    duration: "المدة",
    weekly: "أسبوعي",
    monthly: "شهري",
    weeks: "أسابيع",
    months: "أشهر",
    archived: "مؤرشف",
    paymentMethodDetails: "البيانات التي أضافها التاجر",
    openInGoogleMaps: "فتح الموقع في خرائط Google",
    completed: "مكتمل",
    notCompleted: "غير مكتمل",
    registrationDate: "تاريخ التسجيل",
    verification: "التوثيق",
    status: "الحالة",
    actions: "الإجراءات",
    viewDetails: "عرض التفاصيل",
    noCustomers: "لا يوجد عملاء معتمدون يطابقون التصفية.",
    noMerchants: "لا يوجد تجار معتمدون يطابقون التصفية.",
    noApprovedAccountsHint: "ستظهر الحسابات المعتمدة هنا عند توفرها.",
    customerAccount: "حساب العميل",
    merchantAccount: "حساب التاجر",
    accountDetails: "تفاصيل الحساب",
    resizeDrawer: "تغيير عرض نافذة تفاصيل الحساب",
    resizeRegistrationReviewDrawer: "تغيير عرض نافذة تفاصيل مراجعة التسجيل",
    accountOverviewHint: "بيانات الهوية والتواصل والتسجيل",
    accountActions: "إجراءات الحساب",
    accountActionsHint: "تُسجل الإجراءات الإدارية وقد تتطلب سبباً",
    lifecycleStatus: "حالة الحساب",
    setupStatus: "حالة الإعداد",
    overview: "نظرة عامة",
    documentsTab: "المستندات",
    policiesTab: "السياسات",
    operationsTab: "العمليات",
    logsTab: "السجلات",
    registrationDocuments: "التسجيل والمستندات",
    policyEvidence: "إثبات الموافقات",
    operationsSummary: "ملخص العمليات",
    auditHistory: "سجل التدقيق",
    editProfile: "تعديل الملف",
    block: "حظر",
    unblock: "إلغاء الحظر",
    reopenReview: "إعادة فتح المراجعة",
    softDelete: "حذف الحساب",
    restore: "استعادة الحساب",
    reason: "السبب",
    reasonHint: "اكتب السبب الداخلي المطلوب",
    cancel: "إلغاء",
    confirm: "تأكيد",
    save: "حفظ التعديلات",
    loading: "جارٍ التحميل…",
    pending: "قيد المراجعة",
    rejected: "مرفوض",
    reupload: "مطلوب إعادة الرفع",
    approved: "معتمد",
    logEvent: "الحدث",
    logDate: "التاريخ والوقت",
    logActor: "تم بواسطة",
    logChanges: "التغييرات",
    noAuditLogs: "لا توجد أنشطة مسجلة لهذا الحساب.",
    systemActor: "النظام",
    auditActions: {
      PROFILE_UPDATED: "تحديث الملف الشخصي",
      REVIEW_DECIDED: "اتخاذ قرار مراجعة التسجيل",
      BLOCKED: "حظر الحساب",
      UNBLOCKED: "إلغاء حظر الحساب",
      REVIEW_REOPENED: "النقل إلى قيد المراجعة",
      SOFT_DELETED: "حذف الحساب",
      SELF_DELETED: "حذف صاحب الحساب حسابه",
      RESTORED: "استعادة الحساب",
      DOCUMENTS_SUBMITTED: "رفع المستندات"
    },
    auditActorTypes: {
      SUPER_ADMIN: "مدير النظام",
      ADMIN: "مسؤول",
      CUSTOMER: "عميل",
      MERCHANT: "تاجر",
      SYSTEM: "النظام"
    },
    auditFields: {
      fullName: "اسم العميل",
      nameAr: "اسم المتجر بالعربية",
      nameEn: "اسم المتجر بالإنجليزية",
      ownerFullLegalName: "الاسم القانوني للمالك",
      phone: "الهاتف",
      nationalId: "الرقم القومي",
      registrationNumber: "رقم السجل التجاري",
      decision: "قرار المراجعة",
      compatibilityAlias: "إجراء توافق"
    },
    statusLabels: {
      PENDING_REVIEW: "قيد المراجعة",
      REUPLOAD_REQUIRED: "مطلوب إعادة الرفع",
      REJECTED: "مرفوض",
      APPROVED: "معتمد"
    },
    documentHistory: "سجل مرات الرفع",
    viewDocument: "عرض المستند",
    previous: "السابق",
    next: "التالي",
    page: "صفحة"
  }
};

export const getUserManagementText = (language = "en") =>
  TEXT[language === "ar" ? "ar" : "en"];

export default TEXT;
